import { Inject, Injectable } from '@angular/core';
import { GroupRepository } from '@infrab4a/connect';
import { Observable, from } from 'rxjs';
import { map } from 'rxjs/operators';

export interface HooklabGroup {
  id: number;
  name: string;
  description?: string;
}

export interface HooklabGroupsResponse {
  data: HooklabGroup[];
  total: number;
}

@Injectable({
  providedIn: 'root'
})
export class HooklabService {
  constructor(
    @Inject('GroupRepository') private readonly groupRepository: GroupRepository
  ) {}

  getGroups(offset = 0, limit = 100): Observable<HooklabGroupsResponse> {
    return from(
      this.groupRepository.find({
        limits: {
          offset,
          limit
        },
        options: {
          enableCount: true
        }
      })
    ).pipe(
      map((result) => ({
        data: result.data.map((group) => this.mapGroupToHooklabGroup(group)),
        total: Number(result.count)
      }))
    );
  }

  getGroupById(id: number): Observable<HooklabGroup | null> {
    return from(this.groupRepository.get({ id })).pipe(
      map((group) => (group ? this.mapGroupToHooklabGroup(group) : null))
    );
  }

  getAllGroups(): Observable<HooklabGroup[]> {
    return from(this.groupRepository.find({})).pipe(
      map((result) =>
        result.data.map((group) => this.mapGroupToHooklabGroup(group))
      )
    );
  }

  private mapGroupToHooklabGroup(group: any): HooklabGroup {
    return {
      id:
        typeof group.id === 'string'
          ? parseInt(group.id, 10)
          : Number(group.id),
      name: group.name || `Grupo ${group.id}`,
      description: group.description
    };
  }
}
